import React from 'react';
import { QueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { useQueryDataTableOptions } from '~/shared/data-tables/query/useQueryDataTableOptions';
import type { GroupVisitToTableProps } from './types';

type AssignedToSearchOptionType = 'schedule-report-totals-assigned-to';

export function GroupVisitsByAssignedToTable<T extends AssignedToSearchOptionType>(props: GroupVisitToTableProps<T>) {
	const { searchOptions } = useQueryDataTableOptions();
	const weekFilters = searchOptions.filters.filter(x => x.name === 'weekNumber');

	return (
		<QueryDataTable<T>
			searchType={props.searchType}
			columns={props.columnDefinitions}
			staticFilters={props.staticFilters}
			getRowId={x => x.assignedTo.toString()}
			renderRowDetail={row => (
				<props.tableComponent type="inner" staticFilters={[...weekFilters, { name: 'assignedTo', operator: '==', value: row.assignedTo }]} />
			)}
			emptyMessage="No visits found"
		/>
	);
}
